import { create } from 'zustand';

const useUnseenPrayerRequestsStore = create((set, get) => ({
  unseenTotal: null,
  initialized: false,
  setValue: (newValue) => set({ unseenTotal: Math.max(0, newValue) }),
  decrement: () => {
    set((state) => ({ unseenTotal: Math.max(0, state.unseenTotal - 1) }));
  },
  initialize: (initialValue) => {
    if (!get().initialized && Boolean(initialValue)) {
      set({ unseenTotal: Math.max(0, initialValue), initialized: true });
    }
  },
}));

export { useUnseenPrayerRequestsStore };